module.exports = __webpack_public_path__ + "static/dl2-stay-human_lang-9c983a9d90a5878a5651f9da8a2c7a27.png";